module.exports = __webpack_public_path__ + "static/media/icon-minus.31dfb4f6.svg";